var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComponent373(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_37_3",
    "data-name": "Component 37 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.95,
    height: 33.28,
    viewBox: "0 0 31.95 33.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15025",
    "data-name": "Path 15025",
    d: "M18,34.28A2.67,2.67,0,0,0,20.58,32H15.32A2.67,2.67,0,0,0,18,34.28Z",
    transform: "translate(-3.05 -1)",
    fill: "#0267c1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15026",
    "data-name": "Path 15026",
    d: "M32.85,28.13l-.34-.3A14.37,14.37,0,0,1,30,24.9a12.63,12.63,0,0,1-1.35-4.81V15.15a10.92,10.92,0,0,0-.16-1.79A7.5,7.5,0,0,1,22.5,6V5.37a10.57,10.57,0,0,0-3.32-1V3.11a1.335,1.335,0,1,0-2.67,0V4.42a10.81,10.81,0,0,0-9.3,10.73v4.94A12.63,12.63,0,0,1,5.86,24.9a14.4,14.4,0,0,1-2.47,2.93l-.34.3v2.82h29.8Z",
    transform: "translate(-3.05 -1)",
    fill: "#0267c1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15027",
    "data-name": "Path 15027",
    d: "M35,6a5,5,0,1,1-5-5A5,5,0,0,1,35,6Z",
    transform: "translate(-3.05 -1)",
    fill: "#ff3434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent373);
export default __webpack_public_path__ + "static/media/Component 37 – 3.67b1608e9ec7bfe7adc653d352f8f4f8.svg";
export { ForwardRef as ReactComponent };